import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BigPlayButton, Player, PosterImage } from 'video-react';
import { parseTotalTime, parseTotalTimeMaterialAndEbook } from '../../Utils/Utils';
import Bar from '../Bar';

const LockIcon = () => (
  <div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 17C12.5304 17 13.0391 16.7893 13.4142 16.4142C13.7893 16.0391 14 15.5304 14 15C14 13.89 13.1 13 12 13C11.4696 13 10.9609 13.2107 10.5858 13.5858C10.2107 13.9609 10 14.4696 10 15C10 15.5304 10.2107 16.0391 10.5858 16.4142C10.9609 16.7893 11.4696 17 12 17ZM18 8C18.5304 8 19.0391 8.21071 19.4142 8.58579C19.7893 8.96086 20 9.46957 20 10V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V10C4 8.89 4.9 8 6 8H7V6C7 4.67392 7.52678 3.40215 8.46447 2.46447C9.40215 1.52678 10.6739 1 12 1C12.6566 1 13.3068 1.12933 13.9134 1.3806C14.52 1.63188 15.0712 2.00017 15.5355 2.46447C15.9998 2.92876 16.3681 3.47995 16.6194 4.08658C16.8707 4.69321 17 5.34339 17 6V8H18ZM12 3C11.2044 3 10.4413 3.31607 9.87868 3.87868C9.31607 4.44129 9 5.20435 9 6V8H15V6C15 5.20435 14.6839 4.44129 14.1213 3.87868C13.5587 3.31607 12.7956 3 12 3Z"
        fill="white"
      />
    </svg>
  </div>
);

const VideoPreview = () => {
  const course_detail = useSelector((state) => state.course_detail);
  const course_ebook = useSelector((state) => state.course_ebook);
  const [lectureURLSelected, setLectureURLSelected] = useState(null);
  const [lectureSelected, setLectureSelected] = useState(null);
  const [lessonFrontSelected, setLessonFrontSelected] = useState(null);

  const [videoThumbnail, setVideoThumbnail] = useState(null);

  const parseTime = (durasi) => {
    if (!durasi) return '--';
    if (durasi.duration > 3600) {
      return moment.utc(durasi.duration * 1000).format('H[h] m[m]');
    }

    if (durasi.duration < 60) {
      return moment.utc(durasi.duration * 1000).format('s [s]');
    }

    return moment.utc(durasi.duration * 1000).format('m[m] s[s]');
  };

  useEffect(() => {
    if (course_detail && course_detail.introduction_video_id && course_detail.introductionvideo) {
      setLectureURLSelected(course_detail.introductionvideo.url);
      setLessonFrontSelected('preview');
      setLectureSelected('preview');
      if (course_detail.introduction_photo_id && course_detail.introductionimage) {
        setVideoThumbnail(course_detail.introductionimage.url);
      }
    } else {
      if (course_detail && course_detail.lessons_front && course_detail.lessons_front[0]) {
        if (
          course_detail.lessons_front[0].lectures &&
          course_detail.lessons_front[0].lectures[0] &&
          course_detail.lessons_front[0].lectures[0].mediafile
        ) {
          setLectureSelected(0);
          setLessonFrontSelected(0);
          setLectureURLSelected(null);
          setVideoThumbnail(null);
        }
      }
    }
  }, [course_detail]);

  if (!course_detail) return '';
  // if (course_detail?.is_purchased) return '';
  return (
    <div className="video-preview">
      <div>
        <div>
          <h2>Video Preview</h2>
          {lectureURLSelected ? (
            <CourseVideo url={lectureURLSelected} videoThumbnail={videoThumbnail} />
          ) : (
            <Bar videoPreview />
          )}
        </div>
        <div>
          <div>
            <div>
              <h2>Materi</h2>
              <h2>{`${course_detail.lessons_front.length} Materi${
                course_ebook && course_ebook.length > 0
                  ? ' + ' + course_ebook.length + ' Ebook'
                  : ''
              } | Total durasi ${
                course_ebook && course_ebook.length > 0
                  ? parseTotalTimeMaterialAndEbook(course_detail.lessons_front, course_ebook)
                  : parseTotalTime(course_detail.lessons_front)
              }`}</h2>
            </div>
          </div>

          <div className="lessons">
            {course_detail.introduction_video_id && course_detail.introductionvideo ? (
              <div>
                <div style={{ padding: 0 }}></div>
                <div
                  onClick={() => {
                    setLectureURLSelected(course_detail.introductionvideo.url);
                    setLessonFrontSelected('preview');
                    setLectureSelected('preview');
                  }}
                  className={
                    lessonFrontSelected === 'preview' && lectureSelected === 'preview'
                      ? 'video-preview-selected'
                      : ''
                  }
                >
                  <div style={{ padding: 0 }}></div>
                  <h2 style={{ margin: 0 }}>Preview</h2>
                  <h2>{parseTime(course_detail.introductionvideo)}</h2>
                </div>
              </div>
            ) : (
              ''
            )}
            {course_detail.lessons_front.map((el, i) => (
              <div className="lessons__lesson">
                <div className="lessons__lesson__title">
                  <h2>{el.name}</h2>

                  {el.start_date && el.end_date && (
                    <div className="lessons__lesson__dates">
                      <p className="lessons__lesson__dates__date">
                        Start date: {moment(el?.start_date).format('HH:mm, DD MMMM YYYY')}
                      </p>
                      <p className="lessons__lesson__dates__date">
                        End date: {moment(el?.end_date).format('HH:mm, DD MMMM YYYY')}
                      </p>
                    </div>
                  )}
                </div>
                {el.lectures.map((elLecture, j) => (
                  <>
                    <div
                      title={elLecture.name}
                      className={`${
                        i === lessonFrontSelected && j === lectureSelected
                          ? 'video-preview-selected'
                          : ''
                      } lessons__lesson__item`}
                      onClick={() => {
                        if (
                          course_detail &&
                          course_detail.lessons_front &&
                          course_detail.lessons_front[i]
                        ) {
                          if (
                            course_detail.lessons_front[i].lectures &&
                            course_detail.lessons_front[i].lectures[j] &&
                            course_detail.lessons_front[i].lectures[j].mediafile
                          ) {
                            setLessonFrontSelected(i);
                            setLectureSelected(j);
                            setLectureURLSelected(null);
                          }
                        }
                      }}
                    >
                      <LockIcon />
                      <h2>{elLecture.name}</h2>
                      <h2>{parseTime(elLecture.mediafile)}</h2>
                    </div>
                  </>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

class CourseVideo extends React.Component {
  _isMounted = false;
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  componentDidMount() {
    this._isMounted = true;
    this.player.subscribeToStateChange(this.handleStateChange.bind(this));
    // this.fetchResource(this.props.resource_lecture_id)
  }

  handleStateChange(state) {
    this.setState({
      player: state,
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {}

  render() {
    return (
      <>
        <div className="course-video-preview" onContextMenu={(e) => e.preventDefault()}>
          <Player
            playsInline
            poster={this.props.videoThumbnail}
            src={this.props.url}
            ref={(player) => {
              this.player = player;
            }}
            preload="metadata"
          >
            <BigPlayButton position="center" />
            <PosterImage />
          </Player>
        </div>
      </>
    );
  }
}

export default VideoPreview;
